export default __webpack_public_path__ + "static/media/article_1.b.c2a3d519.png";